import React from 'react'

export default function errorFunction(
  props: unknown,
  componentName: string,
  sendErrorComponentEvent: (data: unknown) => void
) {
  console.error(`Error in component ${componentName} -> Data is empty!`, props)
  sendErrorComponentEvent(props)

  return <></>
}
